// frame: 63b6M @ ui/dogdisk-user.pen
// spec: docs/ui/user-page-flows.md §2.7 63b6M 页面-503

import { ErrorPageView } from './_view'

export function MaintenancePage() {
  return (
    <ErrorPageView
      frameId="63b6M"
      backBtnTestId="ZStsS"
      homeBtnTestId="D4dZI"
      code="503"
      title="服务不可用"
      desc="服务器正在维护中,请稍后再访问"
    />
  )
}
